export const iconFontAwesomeTravelHotelPlaneUp = (
	<i className="fa-solid fa-plane-up"></i>
);
